/**
 * A function to check whether the previous payment was an airport ride
 *
 * @param {Object} prevPayment
 * @returns {boolean}
 */
export const isAirportRide = (prevPayment) => {
  return prevPayment?.airport && prevPayment?.city && prevPayment?.terminal;
};

/**
 * A function to check whether the previous payment was a ride by hours trip
 *
 * @param {Object} prevPayment
 * @returns {boolean}
 */
export const isRideByHours = (prevPayment) => {
  return prevPayment && prevPayment.booking_hours;
};

/**
 * A function to check whether the previous payment was city trip
 *
 * @param {Object} prevPayment
 * @returns {boolean}
 */
export const isCityTrip = (prevPayment) => {
  return prevPayment && !isRideByHours() && !isAirportRide();
};
